import { graphql } from 'react-relay';

// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';

import type {
	useGetCurrentStorageUsageQuery$data,
	useGetCurrentStorageUsageQuery$variables,
} from './__generated__/useGetCurrentStorageUsageQuery.graphql.ts';

interface StorageInfo {
	currentUsage: number;
	isStorageEnforcementGracePeriodComplete?: boolean | null;
	gracePeriodEndDate?: string | null;
	loading: boolean;
	error?: Error;
}

const useGetCurrentStorageUsageQuery = graphql`
	query useGetCurrentStorageUsageQuery {
		storage: confluence_storage {
			bytesUsed
			isStorageEnforcementGracePeriodComplete
			gracePeriodEndDate
		}
	}
`;

export const useGetCurrentStorageUsage = ({
	skip,
}: {
	skip?: boolean;
} = {}): StorageInfo => {
	const { data, loading, error } = useQueryInterop<
		useGetCurrentStorageUsageQuery$data,
		useGetCurrentStorageUsageQuery$variables
	>(useGetCurrentStorageUsageQuery, {
		skip,
	});

	return {
		currentUsage: data?.storage?.bytesUsed ?? 0,
		isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
		gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
		loading,
		error,
	};
};
